<div>
  <div class="modal-header text-left">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="mr-1 fa fa-pencil card-close-icon" aria-hidden="true"></i>
      Manual Journal
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="custom-modal-body">
    <form [formGroup]="form" class="manual-journal-form">
      <ov-suite-input
        id="operation"
        type="dropdown"
        [data]="operationOptions"
        [label]="[]"
        [required]="true"
        [title]="'Operation'"
        formControlName="operation"
      ></ov-suite-input>

      <ov-suite-input
        id="targetType"
        type="dropdown"
        [data]="targetOptions"
        [label]="[]"
        [required]="true"
        [title]="'Target'"
        formControlName="targetType"
      ></ov-suite-input>

      <ov-suite-predictive-text-dropdown
        [title]="'Product SKU'"
        [placeholder]="'Search by SKU or name'"
        [formClass]="ProductSkuModel"
        [searchKeys]="['sku', 'name']"
        [dropdownDisplayKey]="'name'"
        [displayFunction]="formatProduct"
        formControlName="productSku"
      ></ov-suite-predictive-text-dropdown>

      <div *ngIf="isLocationTarget; else userTarget" class="mt-2">
        <ov-suite-predictive-text-dropdown
          [title]="'Location'"
          [placeholder]="'Search by location name'"
          [formClass]="InventoryLocationModel"
          [searchKeys]="['name', 'description']"
          [dropdownDisplayKey]="'name'"
          [displayFunction]="formatLocation"
          formControlName="location"
        ></ov-suite-predictive-text-dropdown>
      </div>

      <ng-template #userTarget>
        <div class="mt-2">
          <ov-suite-predictive-text-dropdown
            [title]="'User'"
            [placeholder]="'Search by name or username'"
            [formClass]="UserModel"
            [searchKeys]="['firstName', 'lastName', 'username', 'email']"
            [dropdownDisplayKey]="'username'"
            [displayFunction]="formatUser"
            formControlName="user"
          ></ov-suite-predictive-text-dropdown>
        </div>
      </ng-template>

      <ov-suite-input
        id="amount"
        type="number"
        [min]="1"
        [required]="true"
        [title]="'Amount'"
        formControlName="amount"
      ></ov-suite-input>

      <ov-suite-input
        id="description"
        type="text"
        [required]="true"
        [title]="'Description'"
        [placeholder]="'Enter a description'"
        formControlName="description"
      ></ov-suite-input>

      <span *ngIf="error" class="text-danger pt-1">{{ error }}</span>
    </form>
  </div>

  <div class="modal-footer d-flex justify-content-between pl-3 pr-3">
    <button type="button" class="btn btn-outline-primary float-left" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-dark float-right" [disabled]="loading || form.invalid || !currentUserId" (click)="submit()">
      <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span *ngIf="!loading">Save</span>
    </button>
  </div>
</div>
